import { useQuery } from "@tanstack/react-query";
import invariant from "tiny-invariant";
import { formatUnits, getContract, parseUnits } from "viem";
import { useChainId, usePublicClient } from "wagmi";

import { bentoUSDPlusABI } from "shared/config/abi";
import { bentoUSDConfig, bentoUSDPlusConfig } from "shared/config/const";
import { QueryOptions } from "shared/types";

type Result = { bentoRate: string; bentoPlusRate: string };

export const useBentoRateQuery = <TData = Result>(
  options?: QueryOptions<Result, unknown, TData>
) => {
  const chainId = useChainId();
  const pc = usePublicClient();
  return useQuery({
    queryKey: ["rates", "bento", chainId],
    queryFn: async () => {
      invariant(pc, "useBentoRateQuery pc is undefined");
      const bento = bentoUSDConfig[chainId];
      const contract = getContract({
        abi: bentoUSDPlusABI,
        address: bentoUSDPlusConfig[chainId].address,
        client: pc,
      });

      const bentoRate = "1";

      const previewWithdraw = await contract.read.previewWithdraw([
        parseUnits("1", 18),
      ]);

      const bentoPlusRate = formatUnits(previewWithdraw, bento.decimals);

      return { bentoRate, bentoPlusRate };
    },
    ...options,
  });
};
